<template>
  <div class="strategy-attention">
    <div class="attention-title">注意事项</div>
    <div class="attention-content">
      <div 
        class="content-item"
        v-for="(item, index) in attentionList" 
        :key="index">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    attention: String,
  },
  data() {
    return {};
  },
  computed: {
    attentionList() {
      return this.attention ? this.attention.split('\n') : '';
    },
  },
};

</script>


<style lang="less" scoped>
.strategy-attention {
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px dashed #FF6464;
  .attention-title {
    background: linear-gradient( 90deg, rgba(244,69,92,0.12) 0%, rgba(244,69,92,0.05) 100%);
    border-radius: 2px;
    font-weight: 600;
    font-size: 16px;
    padding: 16px;
    color: #FF6464;
    display: flex;
    align-items: center;
    &::before {
      content: '!';
      width: 16px;
      height: 16px;
      font-size: 14px;
      border-radius: 50%;
      margin-right: 6px;
      border: 1px solid #FF6464;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .attention-content {
    padding: 16px;
  }

  .content-item {
    display: flex;
    font-size: 14px;
    color: #2F333D;
    line-height: 24px;
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #5F666E;
      margin-top: 10px;
      margin-right: 6px;
      flex-shrink: 0;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/country/country-visa-strategy/components/strategy-form-item/strategy-attention.vue